type Listener = () => void;

let open = false;
const listeners = new Set<Listener>();

const notify = () => {
  listeners.forEach((l) => l());
};

export const splashVisibility = {
  get: () => open,
  set: (next: boolean) => {
    if (open === next) return;
    open = next;
    notify();
  },
  subscribe: (listener: Listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
